import { Button, Dialog } from '@alifd/next';
import React from 'react';

export default function ButtonWithDialog({
  children,
  buttonTitle,
  visible,
  setVisible,
  buttonType = 'normal',
  clearFormValues,
}) {
  return (
    <>
      <Button
        onClick={() => {
          setVisible(true);
        }}
        type={buttonType}
      >
        {buttonTitle}
      </Button>
      <Dialog
        visible={visible}
        onClose={() => {
          if (clearFormValues) {
            clearFormValues();
          }
          setVisible(false);
        }}
        footer={false}
        hasMask
      >
        {children}
      </Dialog>
    </>
  );
}
